import { render, staticRenderFns } from "./transactionHistory.vue?vue&type=template&id=194b6661&scoped=true&"
import script from "./transactionHistory.vue?vue&type=script&lang=js&"
export * from "./transactionHistory.vue?vue&type=script&lang=js&"
import style0 from "./transactionHistory.vue?vue&type=style&index=0&id=194b6661&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194b6661",
  null
  
)

export default component.exports